import dayjs from "dayjs";
import { z } from "zod";

export const teamSchema = z.object({
  name: z.string(),
  description: z.string(),
  list_order: z.coerce.number(),
  image: z.instanceof(File).optional()
});

export const functionSchema = z.object({
  team_id: z.coerce.number(),
  title: z.string(),
  coordinator: z.string().optional(),
  coordinator_amount: z.coerce.number(),
  crew: z.string().optional(),
  crew_amount: z.coerce.number()
});

const motivationSchema = z.object({
  teamId: z.coerce.number().optional(),
  functionId: z.coerce.number().optional(),
  type: z.string().optional(),
  motivation: z.string().min(1).nonempty(),
});

export const sollicitationSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  phone: z.string(),
  birthday: z.date().max(dayjs().subtract(18, "year").toDate(), "Je moet 18 zijn om deel te kunnen uitmaken van de organisatie"),
  student: z.boolean(),
  studyTime: z.coerce.number().nonnegative(),
  motivations: z.object({
    first: motivationSchema,
    second: motivationSchema.optional(),
    third: motivationSchema.optional()
  }),
  source: z.string(),
  eula: z.boolean().refine((a) => a === true, "De EULA moet geaccepteerd worden")
}).refine(s => !s.student || s.studyTime > 0, {
  message: "As a student you should have atleast 1 study year left, the counter includes this academic year",
  path: ["studyTime"]
});

export type SollicitationSchema = z.infer<typeof sollicitationSchema>;

export const archiveSchema = z.object({
  reason: z.string(),
})
